module.exports = __webpack_public_path__ + "static/media/galerija_2017 (16).200a177e.jpg";